<template>
  <div class="detailedPage">
    <section class="wrapper">

    <HeaderComponent />
    <PlanComponent />
    <FooterComponent />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import PlanComponent from "@/components/PlanComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
export default {
  name: "DetailPage",
  components: {
    HeaderComponent,
    PlanComponent,
    FooterComponent,
  },
};
</script>
